/**
 * @flow
 * @relayHash 5b9f5afc89506ccaef4b6b45a82728fc
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type LikesRefetchQueryResponse = {|
  +viewer: ?{| |};
|};
*/


/*
query LikesRefetchQuery(
  $createdAfter: String!
  $eventsLimit: Int!
  $fetchNewEvents: Boolean!
  $fetchNotifications: Boolean!
  $notificationItemsLimit: Int!
  $userId: String!
) {
  viewer {
    ...Likes_viewer_2oXh8v
    id
  }
}

fragment Likes_viewer_2oXh8v on Viewer {
  favoriteNotifications(userId: $userId) @include(if: $fetchNewEvents) {
    id
    hasNewEvents(eventsLimit: $eventsLimit, createdAfter: $createdAfter)
  }
  favoriteNotificationsTiles: favoriteNotifications(userId: $userId) @include(if: $fetchNotifications) {
    ...FavNotifications_favoriteNotificationsTiles_33AUrW
    id
  }
}

fragment FavNotifications_favoriteNotificationsTiles_33AUrW on FavoriteNotifications {
  tiles: notificationsList(createdAfter: $createdAfter, notificationsLimit: $eventsLimit, notificationItemsLimit: $notificationItemsLimit) {
    ...FavNotificationsTileList_tiles
    id
  }
}

fragment FavNotificationsTileList_tiles on FavoriteNotification {
  serviceId
  type
  eventType
  createdDate
  lastViewedDate
  ...FavNotificationsTile_tile
}

fragment FavNotificationsTile_tile on FavoriteNotification {
  type
  eventType
  followingType
  page
  totalResults
  items {
    serviceId
    pdpURL
    ...FavNotificationsTileItem_item
    id
  }
  ...FavNotificationsTileHeader_tile
  ...FavNotificationsTileDescription_tile
}

fragment FavNotificationsTileItem_item on Item {
  pdpURL
  firstPhotoWebPath(size: thumb)
}

fragment FavNotificationsTileHeader_tile on FavoriteNotification {
  type
  name
  createdDate
  lastViewedDate
}

fragment FavNotificationsTileDescription_tile on FavoriteNotification {
  items {
    serviceId
    pdpURL
    id
  }
  eventType
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "createdAfter",
        "type": "String!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "eventsLimit",
        "type": "Int!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "fetchNewEvents",
        "type": "Boolean!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "fetchNotifications",
        "type": "Boolean!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "notificationItemsLimit",
        "type": "Int!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "userId",
        "type": "String!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "LikesRefetchQuery",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Likes_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "createdAfter",
                "variableName": "createdAfter",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "eventsLimit",
                "variableName": "eventsLimit",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "fetchNewEvents",
                "variableName": "fetchNewEvents",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "fetchNotifications",
                "variableName": "fetchNotifications",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "notificationItemsLimit",
                "variableName": "notificationItemsLimit",
                "type": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "LikesRefetchQuery",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "createdAfter",
        "type": "String!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "eventsLimit",
        "type": "Int!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "fetchNewEvents",
        "type": "Boolean!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "fetchNotifications",
        "type": "Boolean!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "notificationItemsLimit",
        "type": "Int!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "userId",
        "type": "String!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "LikesRefetchQuery",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchNotifications",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "favoriteNotificationsTiles",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "userId",
                    "variableName": "userId",
                    "type": "String"
                  }
                ],
                "concreteType": "FavoriteNotifications",
                "name": "favoriteNotifications",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": "tiles",
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "createdAfter",
                        "variableName": "createdAfter",
                        "type": "String"
                      },
                      {
                        "kind": "Variable",
                        "name": "notificationItemsLimit",
                        "variableName": "notificationItemsLimit",
                        "type": "Int"
                      },
                      {
                        "kind": "Variable",
                        "name": "notificationsLimit",
                        "variableName": "eventsLimit",
                        "type": "Int"
                      }
                    ],
                    "concreteType": "FavoriteNotification",
                    "name": "notificationsList",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "FavoriteNotification",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "serviceId",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "type",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "eventType",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "createdDate",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "lastViewedDate",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "followingType",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "page",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "totalResults",
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "args": null,
                            "concreteType": "Item",
                            "name": "items",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "serviceId",
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "pdpURL",
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "id",
                                "storageKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "Item",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "size",
                                        "value": "thumb",
                                        "type": "ImageVersionTypeName!"
                                      }
                                    ],
                                    "name": "firstPhotoWebPath",
                                    "storageKey": "firstPhotoWebPath{\"size\":\"thumb\"}"
                                  }
                                ]
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "name",
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchNewEvents",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "userId",
                    "variableName": "userId",
                    "type": "String"
                  }
                ],
                "concreteType": "FavoriteNotifications",
                "name": "favoriteNotifications",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "createdAfter",
                        "variableName": "createdAfter",
                        "type": "String"
                      },
                      {
                        "kind": "Variable",
                        "name": "eventsLimit",
                        "variableName": "eventsLimit",
                        "type": "Int"
                      }
                    ],
                    "name": "hasNewEvents",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "query LikesRefetchQuery(\n  $createdAfter: String!\n  $eventsLimit: Int!\n  $fetchNewEvents: Boolean!\n  $fetchNotifications: Boolean!\n  $notificationItemsLimit: Int!\n  $userId: String!\n) {\n  viewer {\n    ...Likes_viewer_2oXh8v\n    id\n  }\n}\n\nfragment Likes_viewer_2oXh8v on Viewer {\n  favoriteNotifications(userId: $userId) @include(if: $fetchNewEvents) {\n    id\n    hasNewEvents(eventsLimit: $eventsLimit, createdAfter: $createdAfter)\n  }\n  favoriteNotificationsTiles: favoriteNotifications(userId: $userId) @include(if: $fetchNotifications) {\n    ...FavNotifications_favoriteNotificationsTiles_33AUrW\n    id\n  }\n}\n\nfragment FavNotifications_favoriteNotificationsTiles_33AUrW on FavoriteNotifications {\n  tiles: notificationsList(createdAfter: $createdAfter, notificationsLimit: $eventsLimit, notificationItemsLimit: $notificationItemsLimit) {\n    ...FavNotificationsTileList_tiles\n    id\n  }\n}\n\nfragment FavNotificationsTileList_tiles on FavoriteNotification {\n  serviceId\n  type\n  eventType\n  createdDate\n  lastViewedDate\n  ...FavNotificationsTile_tile\n}\n\nfragment FavNotificationsTile_tile on FavoriteNotification {\n  type\n  eventType\n  followingType\n  page\n  totalResults\n  items {\n    serviceId\n    pdpURL\n    ...FavNotificationsTileItem_item\n    id\n  }\n  ...FavNotificationsTileHeader_tile\n  ...FavNotificationsTileDescription_tile\n}\n\nfragment FavNotificationsTileItem_item on Item {\n  pdpURL\n  firstPhotoWebPath(size: thumb)\n}\n\nfragment FavNotificationsTileHeader_tile on FavoriteNotification {\n  type\n  name\n  createdDate\n  lastViewedDate\n}\n\nfragment FavNotificationsTileDescription_tile on FavoriteNotification {\n  items {\n    serviceId\n    pdpURL\n    id\n  }\n  eventType\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/components/Likes/__generated__/LikesRefetchQuery.graphql.js